module.exports = __webpack_public_path__ + "img/pluto169.edb5dc88.jpg";